import { $ } from "@utils/dom";
import { DATA_ATTR } from "@constants/data-attributes";
import { CSS } from "@constants/css-classes";

/**
 * Initialize accessible mobile navigation toggle functionality
 */
export function initMobileNav(): void {
  const mobileNav = $(DATA_ATTR.MOBILE_NAV);

  if (!mobileNav) return;

  const trigger = $<HTMLButtonElement>(DATA_ATTR.MOBILE_NAV_TRIGGER, mobileNav);
  const menu = $(DATA_ATTR.MOBILE_NAV_MENU, mobileNav);
  const iconOpen = $(DATA_ATTR.MOBILE_NAV_ICON_OPEN, mobileNav);
  const iconClose = $(DATA_ATTR.MOBILE_NAV_ICON_CLOSE, mobileNav);
  const backdrop = $(DATA_ATTR.MOBILE_BACKDROP);

  if (!trigger || !menu) return;

  const openMenu = (): void => {
    trigger.setAttribute("aria-expanded", "true");
    iconOpen?.classList.add(CSS.HIDDEN);
    iconClose?.classList.remove(CSS.HIDDEN);
    menu.classList.remove(CSS.OPACITY_0, CSS.INVISIBLE, CSS.TRANSLATE_Y_NEG_2);
    menu.classList.add(CSS.OPACITY_100, CSS.VISIBLE, CSS.TRANSLATE_Y_0);
    backdrop?.classList.remove(CSS.OPACITY_0, CSS.INVISIBLE);
    backdrop?.classList.add(CSS.OPACITY_100, CSS.VISIBLE);
    document.dispatchEvent(new CustomEvent("mobile-nav:open"));
  };

  const closeMenu = (): void => {
    if (trigger.getAttribute("aria-expanded") !== "true") return;

    trigger.setAttribute("aria-expanded", "false");
    iconOpen?.classList.remove(CSS.HIDDEN);
    iconClose?.classList.add(CSS.HIDDEN);
    menu.classList.add(CSS.OPACITY_0, CSS.INVISIBLE, CSS.TRANSLATE_Y_NEG_2);
    menu.classList.remove(CSS.OPACITY_100, CSS.VISIBLE, CSS.TRANSLATE_Y_0);
    backdrop?.classList.add(CSS.OPACITY_0, CSS.INVISIBLE);
    backdrop?.classList.remove(CSS.OPACITY_100, CSS.VISIBLE);
  };

  const toggleMenu = (): void => {
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";
    isExpanded ? closeMenu() : openMenu();
  };

  trigger.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleMenu();
  });

  trigger.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleMenu();
    }
    if (e.key === "Escape") {
      closeMenu();
      trigger.focus();
    }
  });

  menu.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeMenu();
      trigger.focus();
    }
  });

  document.addEventListener("click", (e) => {
    if (!mobileNav.contains(e.target as Node)) {
      closeMenu();
    }
  });

  document.addEventListener("mobile-sidebar:open", closeMenu);
}
